import React from 'react';
import TextField from '@mui/material/TextField';

export const CustomTextField = React.forwardRef(({ errorMessage, ...props }, ref) => (
  <TextField {...props} ref={ref} variant="outlined" error={!!errorMessage} helperText={errorMessage || ''} />
));
